import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { bgcolor, Container } from "@mui/system";
import { useTranslation } from "react-i18next";
import FaqImage from "../../../assets/faq.png";
import GuidBUySellImage from "../../../assets/guid-buy-sell.png";
import GuidAuthImage from "../../../assets/guid_auth.png";
import WeblogImge from "../../../assets/weblog.png";
// import './LearnMore.css'
import { Box } from "@mui/material";
import AppPicture from "../../../assets/Group 7300.png";
import ChartIcon from "../../../assets/chart-column 1.png";
import SupportIcon from "../../../assets/Group 4816.png";
import EasySellBuyIcon from "../../../assets/money-bill-transfer-solid (1) 1.png";
import { Link } from "react-router-dom";
import BazarPicture from "../../../assets/bazar.png";
import MyketPicture from "../../../assets/myket.png";
import SibappPicture from "../../../assets/sibapp.png";

const Application = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: "background.default", py: 4 }}>
      <Container maxWidth="xl">
        <Stack
          direction={"row"}
          mb={2}
          spacing={4}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              width: "130px",
              height: "1px",
            }}
          ></div>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", mb: 2, color: "text.primary" }}
          >
            {t("application")}
          </Typography>
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              transform: "rotate(-180deg)",
              width: "130px",
              height: "1px",
            }}
          ></div>
        </Stack>
        <Grid container spacing={4} mt={4}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 1, color: "text.primary" }}
            >
              برای راحتی و دسترسی همیشگی به امکانات پارسیان بیت، اپلیکیشن ما را
              استفاده کنید
            </Typography>
            <Stack spacing={1.25} mt={4}>
              <Stack direction={"row"} spacing={1.5} alignItems={"center"}>
                <Box
                  bgcolor={"#FF3DFF"}
                  p={2}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  borderRadius={4}
                >
                  <img src={ChartIcon} alt="chart icon" width="auto" />
                </Box>
                <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
                  {t("manage_your_acc")}
                </Typography>
              </Stack>
              <Stack direction={"row"} spacing={1.5} alignItems={"center"}>
                <Box
                  bgcolor={"#FF3DFF"}
                  p={2}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  borderRadius={4}
                >
                  <img src={SupportIcon} alt="chart icon" width="auto" />
                </Box>
                <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
                  {t("support_app")}
                </Typography>
              </Stack>
              <Stack direction={"row"} spacing={1.5} alignItems={"center"}>
                <Box
                  bgcolor={"#FF3DFF"}
                  p={2}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  borderRadius={4}
                >
                  <img src={EasySellBuyIcon} alt="chart icon" width="auto" />
                </Box>
                <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
                  {t("easy_sell_buy")}
                </Typography>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "start", sm: "center" }}
                spacing={0.5}
                marginTop={"3rem"}
              >
                <Link to="https://cafebazaar.ir/app/com.parsianbit.application">
                  <Box sx={{ width: "auto", mt: 3 }}>
                    <img
                      src={BazarPicture}
                      alt="icon market"
                      width="auto"
                      style={{ borderRadius: "10px" }}
                    />
                  </Box>
                </Link>
                <Link to="/">
                  <Box sx={{ width: "auto", mt: 3 }}>
                    <img
                      src={MyketPicture}
                      alt="icon market"
                      width="auto"
                      style={{ borderRadius: "10px" }}
                    />
                  </Box>
                </Link>
                <Link to="/">
                  <Box sx={{ width: "auto", mt: 3 }}>
                    <img
                      src={SibappPicture}
                      alt="icon market"
                      width="auto"
                      style={{ borderRadius: "10px" }}
                    />
                  </Box>
                </Link>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "end" },
              alignItems: "center",
            }}
          >
            <Box sx={{}}>
              <img src={AppPicture} alt="picture learn more" width="100%" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
export default Application;
